define.alias("shared/components/shared/ui/dynamic-social-set", "settings/components/shared/ui/dynamic-social-set");